import { render } from "./ControllaDilazioni.vue?vue&type=template&id=4419b638&scoped=true"
import script from "./ControllaDilazioni.vue?vue&type=script&lang=js"
export * from "./ControllaDilazioni.vue?vue&type=script&lang=js"

import "./ControllaDilazioni.vue?vue&type=style&index=0&id=4419b638&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4419b638"]])

export default __exports__